import { useZocksQuota } from '../../components/ScopedBlock/hooks'

import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'
import { Documents } from './Documents/Documents'
import { DocumentsInitialization } from './Initialization/DocumentsInitialization'

export const DocumentsPage = () => {
  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return (
    <div className='full-size-content'>
      <DocumentsInitialization />
      <Documents />
    </div>
  )
}
